import makeUrl from '@/utils/makeUrl';
const yqkApiPre = `/api/ylyqCard`;
const yqkApiList = [
	// 绑定园区卡
	'bind',
	// 解绑园区卡
	'removeBind',
	//查询交易流水信息
	'transLists',
	//生成付款码
	'createPayQrcode',
	//园区卡管理
	'cardManage',
	//充值交易流水
	'rechargeLists',
	//园区卡是否可用支付
	'getCardPay'
];
const yqkApi = {};

yqkApiList.forEach(key => {
	yqkApi[`${key}Url`] = makeUrl(yqkApiPre, key);
});

export default yqkApi;